import React, { useContext } from "react";
import styled from "styled-components";

import { INTERACTION_MAP } from "@examspark/common/dist/meta/questions";
import "./Canvas.css";
import { Button } from "@examspark/common-ui";

import { useMediaPlayer } from "./hooks/useMediaPlayer";
import * as Interaction from "./interactions/index";
import QuestionContext from "./QuestionContext";
import Stimulus from "./Stimulus";

import { ItemFontScaling } from ".";

const Sections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  mjx-container[jax="SVG"][display="true"] {
    margin: 0.2em 0;
    display: inline-block;
  }
`;

const MainSection = styled.div`
  /* flex: 1.8; */
`;

const Canvas = () => {
  const media = useMediaPlayer();
  const [state] = useContext(QuestionContext);

  const mainElements: any[] = [];
  // console.log("state", state);

  if (state?.question?.content?.canvas) {
    let idx = -1;
    for (const el of state.question.content.canvas) {
      idx++;
      switch (el.type) {
        case "stimulus":
          mainElements.push(<Stimulus key={idx} data={el} />);
          break;
        case "stem":
          {
            const xtypeProps = {
              key: idx + (el?.id ?? ""),
              data: el,
            };
            switch (el.interactionType) {
              // case "choice":
              //   mainElements.push(<Question.MultipleChoice {...xtypeProps} />);
              //   break;
              default:
                {
                  const interactionClassName = (
                    INTERACTION_MAP[
                      el.interactionType as keyof typeof INTERACTION_MAP
                    ] as any
                  )?.className;

                  if (interactionClassName) {
                    const Stem =
                      // eslint-disable-next-line import/namespace
                      Interaction[
                        // eslint-disable-next-line import/namespace
                        interactionClassName as keyof typeof Interaction
                      ];

                    if (Stem) {
                      mainElements.push(<Stem {...xtypeProps} />);
                    } else {
                      mainElements.push(<></>);
                    }
                  } else {
                    mainElements.push(
                      <>Unsupported Item Type: {el.interactionType}</>,
                    );
                  }
                }
                break;
            }
          }
          break;
      }
    }
  }

  return (
    <ItemFontScaling fontScaling={state?.question?.fontScaling ?? undefined}>
      {state && state.hasMedia && (
        <Button
          title="Play all Audio"
          onClick={(e) => {
            e.stopPropagation();
            media.playAll();
          }}
        >
          Play All Audio
        </Button>
      )}
      <Sections>
        {mainElements.length > 0 && <MainSection>{mainElements}</MainSection>}
      </Sections>
      {!state?.question?.content?.canvas && <div>[No Content]</div>}
    </ItemFontScaling>
  );
};
export default Canvas;
